export default {
  getFollowing: (state) => state.following,
  getFollowers: (state) => state.followers,
  getFollowingCount: (state) => state.followingCount,
  getFollowersCount: (state) => state.followersCount,  
};
